import { api_url } from "../config";
import FileDownload from "js-file-download";
import Axios from "axios";
import { toast } from "react-toastify";

// Le header peut citer le nom (`filename="export.zip"`) : sans nettoyage, le
// fichier serait enregistré avec des guillemets.
const nomDepuisEnTete = (headers) =>
  headers["content-disposition"]?.split("=")[1]?.replace(/"/g, "") || null;

// Avec `responseType: "blob"`, le corps d'une erreur est lui aussi un Blob :
// le message JSON de l'API (`{ other: "…" }`) n'est lisible qu'une fois décodé.
const messageErreur = async (err) => {
  const reponse = err.response;
  if (!reponse?.data) return "Une erreur inconnue est survenue.";

  if (reponse.headers?.["content-type"]?.includes("application/json")) {
    try {
      const corps = JSON.parse(await reponse.data.text());
      if (corps?.other) return corps.other;
    } catch (e) {
      // Corps illisible : on retombe sur le message générique.
    }
  }

  return "Ce fichier est vide, n'existe pas ou ne peut être téléchargé";
};

const downloadTools = {
  /**
   * Récupère un fichier sans le télécharger, pour l'afficher (aperçu PDF).
   * Rend le contenu, les en-têtes de la réponse et le nom du fichier (null si
   * l'API ne le donne pas).
   */
  fetchFile: (path, datas, method = "POST") =>
    Axios({
      url: api_url + path,
      method,
      data: datas,
      responseType: "blob",
    })
      .then((res) => ({
        blob: res.data,
        headers: res.headers,
        filename: nomDepuisEnTete(res.headers),
      }))
      .catch(async (err) => {
        toast.error(await messageErreur(err));
        throw err.response?.data ?? err;
      }),

  downloadFile: (
    path,
    datas,
    filename,
    filenameFromHeader = false,
    method = "POST",
  ) =>
    downloadTools.fetchFile(path, datas, method).then((fichier) => {
      FileDownload(
        fichier.blob,
        (filenameFromHeader && fichier.filename) || filename,
      );
    }),
};

export default downloadTools;
